import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { usePendingReturnContext } from '../context/pending-return-context-provider';
import { ReturnDetails } from '../return';
import { useReturnsPanelContext } from '../side-panel/returns/returns-panel-context-provider';

export const ReturnLoader = ({ returnFulfillmentId }) => {
  const { isPendingReturnSelected } = usePendingReturnContext();

  const isReturnLoaded = useSelector((state) => {
    return (
      isPendingReturnSelected ||
      !!Global.selectEntitiesReturnById(state, {
        fulfillmentId: returnFulfillmentId,
      })
    );
  });

  const { standardReturns: returnFulfillments } = useReturnsPanelContext();

  const counter = useMemo(() => {
    const selectedReturn = returnFulfillments.find((returnFulfillment) => {
      return returnFulfillment.returnFulfillmentId === returnFulfillmentId;
    });
    return selectedReturn ? selectedReturn.counter : 0;
  }, [returnFulfillmentId, returnFulfillments]);

  return (
    isReturnLoaded && <ReturnDetails counter={counter} isNewReturn={isPendingReturnSelected} returnFulfillmentId={returnFulfillmentId} />
  );
};

ReturnLoader.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
};
